export function view(type) {
  return type === 'internal' ? 'Internal' : 'External'
}
